module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/gplay_sp.svg", __webpack_public_path__ + "_/_/_/common/components/mobile/images/gplay_sp.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/gplay_sp.svg
// module id = 599
// module chunks = 2